import React from 'react';
import FadeInAnimation from "../Common/FadeInAnimation";
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslations } from "../../locales/useTranslations";

const SoftwareDevelopmentEigenschaften = () => {
    const { t } = useTranslations();

    return (
        <div className="features-card-section pt-70 pb-70 bg-f8fbfa">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={50} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hover
                                    loop
                                    src="/images/software-development/flexibility-adaptability.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('softwareDevelopment_features_flexibility_title')}</h3>
                                <p>{t('softwareDevelopment_features_flexibility_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={100} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hovers
                                    loop
                                    src="/images/software-development/customer-centric-development.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('softwareDevelopment_features_customerCentric_title')}</h3>
                                <p>{t('softwareDevelopment_features_customerCentric_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={150} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hover
                                    loop
                                    src="/images/software-development/communication.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('softwareDevelopment_features_communication_title')}</h3>
                                <p>{t('softwareDevelopment_features_communication_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={50} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hover
                                    loop
                                    src="/images/lottie/scalableSoftware.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('softwareDevelopment_features_scalable_title')}</h3>
                                <p>{t('softwareDevelopment_features_scalable_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={100} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hover
                                    loop
                                    src="/images/lottie/quality.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('softwareDevelopment_features_quality_title')}</h3>
                                <p>{t('softwareDevelopment_features_quality_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12 feature-card">
                        <FadeInAnimation animateIn="fadeInUp" delay={150} animateOnce={true} style={{ "display": "flex" }}>
                            <div className="single-features-card tx-center">
                                <Player
                                    hover
                                    loop
                                    src="/images/software-development/roi.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('softwareDevelopment_features_roi_title')}</h3>
                                <p>{t('softwareDevelopment_features_roi_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SoftwareDevelopmentEigenschaften;